module.exports = __webpack_public_path__ + "static/media/icon-dropdown-down.40b260e0.svg";